import * as configcat from 'configcat-js';
import { CONFIGCAT_SDK_KEY } from '../config';

// Cliente singleton de ConfigCat (feature flags).
//
// El SDK key es PÚBLICO (read-only, seguro para el front). Usamos AutoPoll: el
// SDK refresca la config en segundo plano cada `pollIntervalSeconds` y la sirve
// desde su cache global por CDN. Ver ADR-135 (por qué el flag de mantenimiento
// vive acá y no en Supabase).
let client: configcat.IConfigCatClient | null = null;

export function getConfigCatClient(): configcat.IConfigCatClient {
  if (!client) {
    client = configcat.getClient(
      CONFIGCAT_SDK_KEY,
      configcat.PollingMode.AutoPoll,
      { pollIntervalSeconds: 30 },
    );
  }
  return client;
}
